import React, { useRef, useEffect, useState } from "react";
import styles from "./CameraMark.module.css";
import NavigationHeader from "../NavigationHeader/NavigationHeader";
import back from "../../assests/backButtonNew.svg";
import PopupWrapper from "../../Layout/PopupWrapper";
import { isEmpty } from "lodash";

const CameraMask = ({
  handleCapture,
  stream,
  setStream,
  handleChoose,
  contestDetails,
  setShowPopup,
}) => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const watermarkRef = useRef(null);
  const [openFrontCam, setOpenFrontCam] = useState(true);
  const [waterMarkSelected, setWaterMarkSelected] = useState(
    contestDetails &&
      contestDetails?.waterMarkImage &&
      contestDetails?.waterMarkImage[0]
  );
  const [filteredWaterMarks, setFilteredWaterMarks] = useState(
    contestDetails?.waterMarkImage || []
  );
  const [cameraError, setCameraError] = useState(null);
  const [switchBg, setSwitchBg] = useState(false);
  const handleChooseFromGallary = () => {
    document.getElementById("galleryInput").click();
  };
  // useEffect(() => {
  //   window.scrollTo(0, 0);
  //   document.body.style.overflow = "hidden";
  //   return () => {
  //     document.body.style.overflow = "unset";
  //   };
  // }, []);

  useEffect(() => {
    startCamera();
    return () => {
      stopCamera();
    };
  }, [waterMarkSelected, openFrontCam]);

  const startCamera = async () => {
    try {
      setCameraError(null);
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: openFrontCam ? "user" : { exact: "environment" } },
      });
      videoRef.current.srcObject = mediaStream;
      videoRef.current.play();
      setStream(mediaStream);
      const frameImage = new Image();
      frameImage.crossOrigin = "anonymous";
      frameImage.src = waterMarkSelected?.fileUrl;
      frameImage.onload = () => {
        console.log("Frame image loaded successfully ....");
        watermarkRef.current = frameImage;
        drawFrameWithCamera();
      };
    } catch (error) {
      console.error("Error accessing webcam:", error);
      handlePermissionDenied();
    }
  };

  const handlePermissionDenied = () => {
    setCameraError(
      new Error(
        "Camera access denied. Please enable camera access in your browser settings."
      )
    );
  };
  const flipImage = (image) => {
    return new Promise((resolve) => {
      const tempCanvas = document.createElement("canvas");
      const tempCtx = tempCanvas.getContext("2d");

      tempCanvas.width = image.width;
      tempCanvas.height = image.height;

      tempCtx.save();
      tempCtx.scale(-1, 1); // Flip horizontally
      tempCtx.translate(-tempCanvas.width, 0); // Move context to the right
      tempCtx.drawImage(image, 0, 0);
      tempCtx.restore();

      const flippedImage = new Image();
      flippedImage.onload = () => resolve(flippedImage);
      flippedImage.src = tempCanvas.toDataURL();
    });
  };

  const handleImageSelection = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const img = new Image();
      img.src = URL.createObjectURL(file);

      img.onload = async () => {
        // Flip the selected image
        const flippedImage = await flipImage(img);

        // Load the watermark image
        const frameImage = new Image();
        frameImage.crossOrigin = "anonymous";
        frameImage.src = waterMarkSelected?.fileUrl;
        frameImage.onload = () => {
          console.log("Frame image loaded successfully ....");
          watermarkRef.current = frameImage;

          // Draw the flipped image and capture
          drawFrameWithCamera(flippedImage);
          captureImage(flippedImage);
        };
      };
    }
  };

  const drawFrameWithCamera = (selectedImage = null) => {
    const canvas = canvasRef.current;
    const video = videoRef.current;

    if (canvas && (video || selectedImage)) {
      const dpr = window.devicePixelRatio || 1;
      const aspectRatio = 4 / 5;

      // Set the canvas size based on DPR
      canvas.width = (video ? video.offsetWidth : canvas.width) * dpr;
      canvas.height = canvas.width / aspectRatio;

      const ctx = canvas.getContext("2d");

      // Scale down the context to draw at the correct size
      ctx.scale(dpr, dpr);
      ctx.clearRect(0, 0, canvas.width / dpr, canvas.height / dpr);

      if (selectedImage) {
        const imageAspectRatio = selectedImage.width / selectedImage.height;
        let sx, sy, sWidth, sHeight;

        if (imageAspectRatio > aspectRatio) {
          sWidth = selectedImage.height * aspectRatio;
          sHeight = selectedImage.height;
          sx = (selectedImage.width - sWidth) / 2;
          sy = 0;
        } else {
          sWidth = selectedImage.width;
          sHeight = selectedImage.width / aspectRatio;
          sx = 0;
          sy = (selectedImage.height - sHeight) / 2;
        }

        ctx.drawImage(
          selectedImage,
          sx,
          sy,
          sWidth,
          sHeight,
          0,
          0,
          canvas.width / dpr,
          canvas.height / dpr
        );
      } else if (video) {
        const videoWidth = video.videoWidth;
        const videoHeight = video.videoHeight;
        const videoAspectRatio = videoWidth / videoHeight;

        let sx, sy, sWidth, sHeight;

        if (videoAspectRatio > aspectRatio) {
          sWidth = videoHeight * aspectRatio;
          sHeight = videoHeight;
          sx = (videoWidth - sWidth) / 2;
          sy = 0;
        } else {
          sWidth = videoWidth;
          sHeight = videoWidth / aspectRatio;
          sx = 0;
          sy = (videoHeight - sHeight) / 2;
        }

        ctx.drawImage(
          video,
          sx,
          sy,
          sWidth,
          sHeight,
          0,
          0,
          canvas.width / dpr,
          canvas.height / dpr
        );
      }

      if (watermarkRef.current) {
        const frameWidth = canvas.width / dpr;
        const frameHeight = canvas.height / dpr;
        if (openFrontCam) {
          ctx.save();
          ctx.scale(-1, 1);

          ctx.drawImage(
            watermarkRef.current,
            -frameWidth,
            0,
            frameWidth,
            frameHeight
          );
        } else {
          ctx.drawImage(watermarkRef.current, 0, 0, frameWidth, frameHeight);
        }
        ctx.restore();
      }

      if (!selectedImage) {
        requestAnimationFrame(() => drawFrameWithCamera());
      }
    }
  };

  const captureImage = async (selectedImage = null) => {
    if (cameraError && !selectedImage) {
      await startCamera();
      return;
    }

    try {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");

      // Create a temporary canvas for flipping
      const tempCanvas = document.createElement("canvas");
      const tempCtx = tempCanvas.getContext("2d");

      // Set the size of the temporary canvas
      tempCanvas.width = canvas.width;
      tempCanvas.height = canvas.height;

      if (openFrontCam) {
        // Apply mirroring to the temporary canvas
        tempCtx.save(); // Save the current state
        tempCtx.scale(-1, 1); // Flip horizontally
        tempCtx.translate(-tempCanvas.width, 0); // Move context to the right
      }

      // Draw the original canvas content onto the temporary canvas
      tempCtx.drawImage(canvas, 0, 0);

      // Restore the context to its original state
      tempCtx.restore();

      // Convert the flipped temporary canvas content to a Blob
      tempCanvas.toBlob((blob) => {
        if (blob) {
          const pngFile = new File(
            [blob],
            "image.png", // Give the file a name
            { type: "image/png" } // Set the MIME type to PNG
          );
          handleCapture(pngFile);
          stopCamera();
        }
      });
    } catch (error) {
      console.error("Error capturing image:", error);
    }
  };

  const stopCamera = () => {
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
      setStream(null);
    }
  };
  const handleSwitchBg = () => {
    stopCamera();
    setSwitchBg(true);
  };
  const handleSearch = (searchValue) => {
    setFilteredWaterMarks(() => {
      if (!searchValue) {
        return contestDetails?.waterMarkImage || [];
      }
      let waterMarkFilter = contestDetails?.waterMarkImage?.filter((el) =>
        el?.name?.toLowerCase()?.includes(searchValue?.toLowerCase())
      );
      return waterMarkFilter;
    });
  };
  const handleChangeWaterMark = (option) => {
    stopCamera();
    setWaterMarkSelected(option);
  };
  return (
    <div className={`${styles.container} no-scrollbar`}>
      {switchBg && (
        <PopupWrapper>
          <div className={styles.popupWrapper}>
            <div
              className={`${styles.cameraGradient} overflow-auto h-full max-w-[425px] no-scrollbar`}
            >
              <div className=" flex items-center justify-between w-[100%] py-[12px] px-[20px] sticky top-0 bg-black z-10">
                <img
                  src={back}
                  alt=""
                  className="w-[40px] h-[40px] hover:cursor-pointer dismissButton z-[1]"
                  onClick={() => {
                    startCamera();
                    setSwitchBg(false);
                    handleSearch("");
                  }}
                />
                <p className="text-regular-medium text-[#fff] w-full text-center">
                  {contestDetails?.pbButtonText || "Choose Photo Booth Frame"}
                </p>
                <div className="w-[40px]" />
              </div>
              <div className="w-full px-[20px] pt-[20px] pb-[50px]">
                <div className="w-full flex flex-col items-center">
                  <div className={styles.searchBox}>
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.3501 13.3562C13.2568 13.4482 13.1311 13.4998 13.0001 13.5C12.8673 13.4994 12.7398 13.448 12.6438 13.3562L9.94385 10.65C8.80671 11.6051 7.34474 12.0844 5.86285 11.9878C4.38095 11.8912 2.99355 11.2263 1.99 10.1316C0.986453 9.037 0.444243 7.5972 0.476455 6.1125C0.508667 4.62782 1.11282 3.21288 2.1629 2.1628C3.21298 1.11272 4.62791 0.508568 6.1126 0.476356C7.59729 0.444143 9.0371 0.986354 10.1317 1.9899C11.2264 2.99345 11.8913 4.38085 11.9879 5.86275C12.0845 7.34465 11.6052 8.80661 10.6501 9.94375L13.3501 12.6437C13.3973 12.6903 13.4349 12.7457 13.4605 12.8069C13.4861 12.8681 13.4993 12.9337 13.4993 13C13.4993 13.0663 13.4861 13.1319 13.4605 13.1931C13.4349 13.2543 13.3973 13.3097 13.3501 13.3562ZM6.2501 11C7.18956 11 8.10792 10.7214 8.88906 10.1995C9.67019 9.67754 10.279 8.93569 10.6385 8.06774C10.998 7.1998 11.0921 6.24473 10.9088 5.32332C10.7255 4.40191 10.2732 3.55554 9.60885 2.89124C8.94455 2.22694 8.09819 1.77455 7.17678 1.59127C6.25537 1.40799 5.3003 1.50205 4.43235 1.86157C3.5644 2.22109 2.82255 2.82991 2.30062 3.61104C1.77868 4.39217 1.5001 5.31054 1.5001 6.25C1.50175 7.50927 2.00273 8.71649 2.89317 9.60693C3.78361 10.4974 4.99083 10.9983 6.2501 11Z"
                        fill="black"
                      />
                    </svg>

                    <input
                      className="w-[100%] text-[#000]"
                      style={{ backgroundColor: "transparent" }}
                      type="text"
                      placeholder="Search"
                      onChange={(e) => handleSearch(e.target.value)}
                    />
                  </div>
                  {contestDetails?.waterMarkType == "LIST" ? (
                    <div className="w-full">
                      {isEmpty(contestDetails?.waterMarkFilter) ? (
                        <div className="w-full">
                          {filteredWaterMarks?.map((option, index) => (
                            <div
                              key={index}
                              className="flex w-full items-center justify-between backdrop-blur-sm rounded-[8px] gap-[12px] p-[4px] mb-[20px] cursor-pointer"
                              style={{
                                background:
                                  option?._id === waterMarkSelected?._id &&
                                  "#ffffff1A",
                              }}
                              onClick={() => {
                                setWaterMarkSelected(option);
                                setSwitchBg(false);
                              }}
                            >
                              <div className="w-[25%] rounded-[8px] overflow-hidden">
                                <img
                                  src={option?.fileUrl}
                                  className="aspect-square object-contain w-full rounded-[8px] bg-white"
                                />
                              </div>
                              <div className="w-full">
                                <p className="text-regular-callout mb-[4px]">
                                  {option?.name}
                                </p>
                                <p className="text-small text-[#606060]">
                                  {option?.location}
                                </p>
                              </div>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M10 6L8.59003 7.41L13.17 12L8.59003 16.59L10 18L16 12L10 6Z"
                                  fill="white"
                                />
                              </svg>
                            </div>
                          ))}
                        </div>
                      ) : (
                        contestDetails?.waterMarkFilter?.map((filter) => {
                          var groupArray = filteredWaterMarks?.filter(
                            (el) => el?.groupId == filter?.groupId
                          );
                          if (!isEmpty(groupArray)) {
                            return (
                              <div className="mb-[30px]" key={filter?.groupId}>
                                <p
                                  className="text-[#cdcdcd] text-regular-bold mb-[10px]"
                                  style={{ color: contestDetails?.buttonColor }}
                                >
                                  {filter?.name}
                                </p>
                                <div className="w-full">
                                  {groupArray?.map((option, index) => (
                                    <div
                                      key={option?._id}
                                      className="flex w-full items-center justify-between backdrop-blur-sm rounded-[8px] gap-[12px] p-[4px] mb-[20px] cursor-pointer"
                                      style={{
                                        background:
                                          option?._id ===
                                            waterMarkSelected?._id &&
                                          "#ffffff1A",
                                      }}
                                      onClick={() => {
                                        setWaterMarkSelected(option);
                                        setSwitchBg(false);
                                      }}
                                    >
                                      <div className="w-[25%] rounded-[8px] overflow-hidden">
                                        <img
                                          src={option?.fileUrl}
                                          className="aspect-square object-contain w-full rounded-[8px] bg-white"
                                        />
                                      </div>
                                      <div className="w-full">
                                        <p className="text-regular-callout mb-[4px]">
                                          {option?.name}
                                        </p>
                                        <p className="text-small text-[#606060]">
                                          {option?.location}
                                        </p>
                                      </div>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                      >
                                        <path
                                          d="M10 6L8.59003 7.41L13.17 12L8.59003 16.59L10 18L16 12L10 6Z"
                                          fill="white"
                                        />
                                      </svg>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            );
                          }
                        })
                      )}
                    </div>
                  ) : (
                    <div className="flex gap-[16px] grid grid-cols-2">
                      {filteredWaterMarks?.map((obj, i) => {
                        return (
                          <div key={i}>
                            {obj?.fileUrl && (
                              <button
                                className={styles.filterChipsButton}
                                style={
                                  obj?._id === waterMarkSelected?._id
                                    ? {
                                        backgroundColor: "white",
                                        color: "black",
                                      }
                                    : {}
                                }
                                onClick={() => {
                                  setWaterMarkSelected(obj);
                                  setSwitchBg(false);
                                }}
                              >
                                <img
                                  src={obj?.fileUrl ? obj?.fileUrl : null}
                                  alt=""
                                  className="rounded-[16px] object-contain w-full h-full"
                                />
                              </button>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                  {isEmpty(filteredWaterMarks) && (
                    <p className="text-small-bold w-[80%]  text-[cdcdcd] text-center my-[30px] opacity-80">
                      No results found for your search. Please try different
                      keywords
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </PopupWrapper>
      )}
      <div className={styles.cameraGradient}>
        <NavigationHeader
          type="mask"
          isFixed={false}
          backFunction={() => {
            stopCamera();
            setShowPopup(false);
          }}
          contestDetails={contestDetails}
          handleSwitchBg={handleSwitchBg}
          waterMarkSelected={waterMarkSelected}
          handleChangeWaterMark={handleChangeWaterMark}
        />

        <div className="w-full px-[20px]">
          <div className="w-full flex flex-col items-center">
            {/* <p className="text-regular-medium mt-[50px] text-[#fff] mx-auto text-center">
              Center your face and tap the <br /> button to take your photo.
            </p> */}
          </div>
        </div>
        <div className="relative overflow-hidden w-full border-[5px] border-[#2264E6] p-[2px] mx-auto aspect-[4/5]">
          <video
            ref={videoRef}
            autoPlay
            playsInline
            width="100%"
            // height="100%"
            style={{
              objectFit: "cover",
              transform: openFrontCam ? "scaleX(-1)" : "",
            }}
            className="opacity-0 w-full h-full absolute top-0 left-0 transform overflow-hidden aspect-[4/5]"
          />
          <canvas
            ref={canvasRef}
            style={{ transform: openFrontCam ? "scaleX(-1)" : "" }}
            className="absolute top-0 left-0 transform overflow-hidden aspect-[4/5]"
          />
          {cameraError?.message && (
            <div className=" absolute top-0 left-0 w-full h-full flex flex-col items-center justify-center">
              <p className="text-small-medium text-center px-[20px] text-[#c61b1b] z-10 relative">
                {cameraError?.message}
              </p>
              <p className="text-small-medium mt-[16px]">OR</p>
              <button
                onClick={handleChooseFromGallary}
                style={{
                  backgroundColor: contestDetails?.buttonColor,
                }}
                className="commonButton text-regular-medium w-fit mt-[16px] mx-auto z-10 relative"
              >
                Choose From Gallary
              </button>

              <img
                src={waterMarkSelected?.fileUrl}
                className="w-full h-full absolute top-0 left-0 w-full h-full"
              />
            </div>
          )}
          <input
            type="file"
            accept="image/*"
            onChange={handleImageSelection}
            style={{ display: "none" }}
            id="galleryInput"
          />
        </div>
        {/* <div className="h-[100px]" /> */}

        <div className="w-full mt-[25px] fixed  bottom-[0px] left-0 right-0 px-[20px] max-w-[425px] p-[20px] mx-auto rounded-t-[24px]">
          {/* {contestDetails?.waterMarkImage?.length > 1 && (
            <button
              className="w-full px-[10px] py-[8px] bg-[#222] rounded-[8px] flex items-center justify-between gap-[8px] mb-[24px]"
              onClick={handleSwitchBg}
            >
              <div className=" w-[32px] h-[32px] rounded-[4px] overflow-hidden shrink-0">
                <img
                  src={waterMarkSelected?.fileUrl}
                  className="aspect-square object-contain w-full h-full rounded-[4px] bg-white"
                />
              </div>

              <p className="text-small opacity-60 text_1Line">
                {waterMarkSelected?.name}
              </p>
              <p style={{ color: contestDetails?.buttonColor }}>
                {contestDetails?.pbButtonText || "Choose Photo Frame"}
              </p>
            </button>
          )} */}
          <div className="flex items-start justify-center gap-[20px] ">
            {!cameraError?.message && (
              <div className="">
                <button
                  style={{
                    background: "#232323",
                    minWidth: "auto",
                    padding: "14px",
                  }}
                  className="commonButton text-black text-small-bold mx-auto"
                  onClick={() => {
                    setOpenFrontCam((prevState) => !prevState);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M3.15009 10.875C3.26259 10.875 3.41259 10.8375 3.52509 10.8L7.68759 9.33748C8.13759 9.18748 8.36259 8.69998 8.21259 8.24998C8.06259 7.79998 7.57509 7.57498 7.12509 7.72498L4.53759 8.62498C5.77509 5.39998 8.92509 3.22498 12.5251 3.22498C16.4626 3.22498 19.8751 5.84998 20.8501 9.59998C20.9626 10.05 21.4126 10.3125 21.8626 10.2C22.3126 10.0875 22.5751 9.63748 22.4626 9.18748C21.3001 4.68748 17.2126 1.53748 12.4876 1.53748C8.28759 1.53748 4.57509 4.01248 3.03759 7.72498L2.25009 5.47498C2.10009 5.02498 1.61259 4.79998 1.16259 4.94998C0.712587 5.09998 0.487587 5.58748 0.637587 6.03748L2.06259 10.125C2.28759 10.6125 2.70009 10.875 3.15009 10.875ZM23.2876 18.6375L21.7501 14.625C21.6376 14.3625 21.4501 14.1375 21.1876 14.025C20.9251 13.9125 20.6251 13.9125 20.3626 14.025L16.2376 15.6C15.7876 15.75 15.6001 16.2375 15.7501 16.6875C15.9001 17.1375 16.3876 17.325 16.8376 17.175L19.4251 16.2C17.9251 18.9375 15.0001 20.7375 11.7376 20.7375C8.02509 20.7375 4.76259 18.4125 3.60009 14.9625C3.45009 14.5125 2.96259 14.2875 2.55009 14.4375C2.10009 14.5875 1.87509 15.075 2.02509 15.4875C3.41259 19.6125 7.31259 22.3875 11.7376 22.3875C15.6001 22.3875 19.0876 20.25 20.8501 16.95L21.7126 19.2375C21.8251 19.575 22.1626 19.7625 22.5001 19.7625C22.6126 19.7625 22.6876 19.7625 22.8001 19.6875C23.2501 19.575 23.4376 19.0875 23.2876 18.6375Z"
                      fill="white"
                    />
                  </svg>
                </button>
                <p className="text-smallest3 text-center mt-[8px]">
                  Switch Camera
                </p>
              </div>
            )}

            <div>
              <button
                style={{
                  background: "#232323",
                  minWidth: "auto",
                  padding: "14px",
                }}
                className="commonButton text-black text-small-bold mx-auto"
                onClick={handleChooseFromGallary}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    opacity="0.5"
                    d="M18 10H13"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    opacity="0.5"
                    d="M10 3H16.5C16.964 3 17.197 3 17.392 3.026C18.0465 3.11232 18.6543 3.41211 19.1211 3.87893C19.5879 4.34574 19.8877 4.9535 19.974 5.608C20 5.803 20 6.036 20 6.5"
                    stroke="white"
                    stroke-width="1.5"
                  />
                  <path
                    d="M2 6.95C2 6.067 2 5.626 2.07 5.258C2.21922 4.46784 2.60314 3.741 3.17165 3.17231C3.74017 2.60361 4.46689 2.21947 5.257 2.07C5.626 2 6.068 2 6.95 2C7.336 2 7.53 2 7.716 2.017C8.51705 2.09223 9.27679 2.40728 9.896 2.921C10.04 3.04 10.176 3.176 10.45 3.45L11 4C11.816 4.816 12.224 5.224 12.712 5.495C12.9802 5.64449 13.2648 5.7626 13.56 5.847C14.098 6 14.675 6 15.828 6H16.202C18.834 6 20.151 6 21.006 6.77C21.0853 6.84 21.16 6.91467 21.23 6.994C22 7.849 22 9.166 22 11.798V14C22 17.771 22 19.657 20.828 20.828C19.656 21.999 17.771 22 14 22H10C6.229 22 4.343 22 3.172 20.828C2.001 19.656 2 17.771 2 14V6.95Z"
                    stroke="white"
                    stroke-width="1.5"
                  />
                </svg>
              </button>
              <p className="text-smallest3 text-center mt-[8px]">Gallery</p>
            </div>

            {!cameraError?.message && (
              <button
                onClick={captureImage}
                style={{
                  backgroundColor: contestDetails?.buttonColor,
                  minWidth: "auto",
                  flex: 1,
                  width: "100%",
                  padding: "14px",
                  lineHeight: "24px",
                }}
                className="commonButton text-small-bold"
              >
                Take Photo
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CameraMask;
